// extracted by mini-css-extract-plugin
module.exports = {"timeSetting":"index_timeSetting__16UI3","title":"index_title__2hDpM","items":"index_items__W-Qqw","timeItem":"index_timeItem__2LVh0","selected":"index_selected__3YVU-"};